/* eslint-disable no-console */
export const error = (fn, error) => console.warn(`⚠️ Función: ${fn} 💬 Mensaje:`, error);

export const debug = (fn, message) => console.log(`🧾 Función: ${fn}`, message);

export const log = { error, debug };
